import { useState, useEffect } from 'react'
import { getTrainingListStatusAPI } from '../services/certificate'

function UseTestPass() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListStatusAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.status }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseTestPass
